import { Domain } from "@/types/domain";

export const downstreamDomains: Domain[] = [
  {
    symbol: "Reft",
    name: "Refining Technologies",
    categories: "Catalytic Cracking, Hydroprocessing, FCC, Refinery Configuration Optimization"
  },
  {
    symbol: "Petr",
    name: "Petrochemical Production",
    categories: "Ethylene/Propylene Production, Polymer Synthesis, Aromatics Processing, MTO Technologies"
  },
  {
    symbol: "Fuel",
    name: "Fuel Blending",
    categories: "Gasoline/Diesel Blending, Fuel Additives, Biofuel Integration, Emission Reduction"
  },
  {
    symbol: "Logd",
    name: "Logistics & Distribution",
    categories: "Supply Chain Optimization, Fuel Storage, Distribution Networks, Terminal Operations"
  },
  {
    symbol: "Retl",
    name: "Retail & Marketing",
    categories: "Fuel Station Management, Marketing Strategies, Consumer Trends, Loyalty Programs"
  },
  {
    symbol: "Hsed",
    name: "HSE Standards",
    categories: "Refinery Safety, Environmental Assessments, Air Emission Controls, Risk Management"
  },
  {
    symbol: "Ener",
    name: "Energy Optimization",
    categories: "Heat Integration, Energy Recovery, AI Process Optimization, Energy Audits"
  },
  {
    symbol: "Susd",
    name: "Sustainability",
    categories: "Carbon Capture, Emission Control, Wastewater Treatment, Biofuels Integration"
  },
  {
    symbol: "Regd",
    name: "Regulatory Compliance",
    categories: "Environmental Regulations, Emission Reporting, Fuel Standards, Compliance"
  },
  {
    symbol: "Digt",
    name: "Digital Transformation",
    categories: "IoT Operations, Predictive Maintenance, Digital Twin, Automation"
  },
  {
    symbol: "Emrg",
    name: "Emergency Response",
    categories: "Risk Assessment, Emergency Shutdown, Crisis Management, Fire Safety"
  },
  {
    symbol: "Schd",
    name: "Supply Chain",
    categories: "Inventory Management, Storage Optimization, Distribution Logistics, Demand Forecasting"
  },
  {
    symbol: "Wast",
    name: "Waste Management",
    categories: "Solid Waste, Sludge Treatment, Waste Gas Recovery, Circular Economy"
  },
  {
    symbol: "Qual",
    name: "Quality Control",
    categories: "Fuel Standards, Process Monitoring, Testing Protocols, Real-time Quality Control"
  },
  {
    symbol: "Acat",
    name: "Advanced Catalysis",
    categories: "Catalyst Development, Regeneration, Poisoning Prevention, Emission Reduction"
  }
];